import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.scss";
import { useTranslation } from "react-i18next";
import HeaderSimple from "../../components/HeaderSimple/HeaderSimple";
import api from "../../../services/api"; // Instância do axios com interceptors

function Login() {
  const [user, setUser] = useState({ email: "", password: "" });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkToken = async () => {
      const savedToken = localStorage.getItem("token");
      if (savedToken) {
        try {
          const response = await api.get("/user");
          if (response.status === 200) {
            navigate("/home");
          }
        } catch (err) {
          console.error("Token inválido ou expirado:", err);
          localStorage.removeItem("token");
          localStorage.removeItem("typeUser");
        }
      }
    };

    checkToken();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const response = await api.post("/login", user);

      const access_token = response.data.access_token;
      const authorizationType = response.data.token_type;
      const fullToken = `${authorizationType} ${access_token}`;

      localStorage.setItem("token", fullToken);

      // Busca dados do usuário após login
      const responseUser = await api.get("/user");
      const roles = responseUser.data.level.roles;
      const role = Object.keys(roles).find((key) => roles[key] === true);
      localStorage.setItem("typeUser", role);

      navigate("/home");
    } catch (error) {
      if (error.response?.data?.error) {
        setError(error.response.data.error);
      } else {
        setError(t("login-error"));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <HeaderSimple />
      <section className="welcome">
        <div className="container">
          <h1 className="titulo">{t("welcome-title")}</h1>
          <p className="texto">{t("welcome-text")}</p>
          <form className="column" onSubmit={handleSubmit}>
            <input
              type="email"
              name="email"
              placeholder={t("welcome-input-1")}
              onChange={handleChange}
              required
              value={user.email}
            />
            <input
              type="password"
              name="password"
              placeholder={t("welcome-input-2")}
              onChange={handleChange}
              required
              value={user.password}
            />
            {error && <p className="error">{error}</p>}
            <button className="button" type="submit" disabled={isLoading}>
              {isLoading ? t("loading-button") : t("welcome-button")}
            </button>
            <Link className="link" to="/recuperar-senha">
              {t("welcome-link-1")}
            </Link>
            <Link className="link" to="/cadastro">
              {t("welcome-link-2")}
            </Link>
          </form>
        </div>
      </section>
    </>
  );
}

export default Login;
